export type FileType = 'csv' | 'json' | 'python' | 'txt';

export const formatDateForFilename = (date: Date): string => {
  const pad = (n: number) => n.toString().padStart(2, '0');
  return `${date.getFullYear().toString().slice(-2)}${pad(date.getMonth() + 1)}${pad(date.getDate())}_${pad(date.getHours())}${pad(date.getMinutes())}${pad(date.getSeconds())}`;
};

export const getMimeType = (fileType: FileType): string => {
  const types: Record<FileType, string> = {
    csv: 'text/csv;charset=utf-8;',
    txt: 'text/txt;charset=utf-8;',
    json: 'application/json;charset=utf-8;',
    python: 'text/plain;charset=utf-8;'
  };
  return types[fileType];
};

export const downloadAsFile = (fileContent: string, fileType: FileType): void => {
  const timestamp = formatDateForFilename(new Date());
  const mimeType = getMimeType(fileType);
  const extension = fileType === 'python' ? 'py' : fileType;

  const blob = new Blob([fileContent], { type: mimeType });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.download = `GX-Data_${timestamp}.${extension}`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  if (typeof URL.revokeObjectURL === 'function') {
    setTimeout(() => {
      URL.revokeObjectURL(url);
    }, 0);
  }
};
